import { anyOf, enumOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants";

const { AMAZON_BEDROCK_AUTH_TYPES } = sharedConstants.AGENTIC_CREDENTIAL;

const isBaseIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  api_key: anyOf(string, () => true),
  connected_at: anyOf(string, () => true),
});

const isGeminiIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  api_key: anyOf(string, () => true),
  connected_at: anyOf(string, () => true),
  use_vertex_ai: boolean,
  vertex_project_id: anyOf(string, () => true),
  use_oauth: maybe(boolean),
  google_account_email: anyOf(string, () => true),
  oauth_connected_at: anyOf(string, () => true),
  oauth_project_id: anyOf(string, () => true),
  oauth_project_name: anyOf(string, () => true),
  oauth_connected: maybe(boolean),
  oauth_pending: maybe(boolean),
});

const isDatabricksMosaicIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  api_key: string,
  connected_at: string,
  workspace_name: string,
});

const isMicrosoftFoundryIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  api_key: string,
  connected_at: string,
  project_name: string,
});

const isAmazonBedrockIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  // Null for role-auth integrations, which store no long-term API key.
  api_key: anyOf(string, () => true),
  connected_at: string,
  aws_region: string,
  auth_type: maybe(enumOf(AMAZON_BEDROCK_AUTH_TYPES.KEY, AMAZON_BEDROCK_AUTH_TYPES.ROLE)),
  role_arn: anyOf(string, () => true),
  external_id: anyOf(string, () => true),
});

export const isGetAlloysAmazonBedrockAgenticExternalIdResult = objectOf({
  external_id: string,
  account_id: string,
});

export const isGetAlloysProviderAgenticAppGroupIdResult = objectOf({
  integration: anyOf(
    isGeminiIntegration,
    isDatabricksMosaicIntegration,
    isMicrosoftFoundryIntegration,
    isAmazonBedrockIntegration,
    isBaseIntegration,
    objectOf({})
  ),
});
